import { VIPCircleActionTypes } from "./vipcircle.model";

export const initialState = {
    vipcircles: [],
    vipCircle: {},
    userVIPCircles: [],
    isLoading: false,
    subscriptions: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case VIPCircleActionTypes.CREATE_VIP_CIRCLE_REQUEST:
        case VIPCircleActionTypes.FETCH_VIP_SUBSCRIPTION_REQUEST:
        case VIPCircleActionTypes.DELETE_VIP_CIRCLE_REQUEST:
        case VIPCircleActionTypes.UPSERT_VIP_CIRCLE_REQUEST:
        case VIPCircleActionTypes.SEND_VIP_CIRCLE_REQUEST:
        case VIPCircleActionTypes.UPDATE_VIP_CIRCLE_REQUEST:
        case VIPCircleActionTypes.FETCH_VIP_CIRCLE_REQUEST: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }

        case VIPCircleActionTypes.FETCH_OTHER_VIP_CIRCLE_REQUEST: {
            return Object.assign({}, state, {
                isLoading: true,
                userVIPCircles: [],
            });
        }

        case VIPCircleActionTypes.CREATE_VIP_CIRCLE_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                vipCircle: action.payload.data,
                vipcircles: [...state.vipcircles, action.payload.data],
            });
        }

        case VIPCircleActionTypes.UPDATE_VIP_CIRCLE_SUCCESS: {
            let vipCircles = state.vipcircles.map((x) => {
                if (x._id === action.payload.data._id) {
                    x = action.payload.data;
                }
                return x;
            });
            return Object.assign({}, state, {
                isLoading: false,
                vipCircle: action.payload.data,
                vipcircles: vipCircles,
            });
        }

        case VIPCircleActionTypes.FETCH_VIP_CIRCLE_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                vipcircles: action.payload.data.filter(
                    (x) => x.status === "Active"
                ),
            });
        }

        case VIPCircleActionTypes.DELETE_VIP_CIRCLE_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
            });
        }

        case VIPCircleActionTypes.UPSERT_VIP_CIRCLE_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
            });
        }

        case VIPCircleActionTypes.SEND_VIP_CIRCLE_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
            });
        }

        case VIPCircleActionTypes.EDIT_VIP_CIRCLE_REQUEST: {
            return Object.assign({}, state, {
                isLoading: false,
                vipCircle: action.payload,
            });
        }

        case VIPCircleActionTypes.FETCH_OTHER_VIP_CIRCLE_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                userVIPCircles: action.payload.data.filter(
                    (x) => x.status === "Active"
                ),
            });
        }

        case VIPCircleActionTypes.FETCH_VIP_SUBSCRIPTION_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                subscriptions: action.payload.data,
            });
        }

        case VIPCircleActionTypes.CREATE_VIP_CIRCLE_FAILURE:
        case VIPCircleActionTypes.DELETE_VIP_CIRCLE_FAILURE:
        case VIPCircleActionTypes.UPDATE_VIP_CIRCLE_FAILURE:
        case VIPCircleActionTypes.FETCH_VIP_CIRCLE_FAILURE:
        case VIPCircleActionTypes.UPSERT_VIP_CIRCLE_FAILURE:
        case VIPCircleActionTypes.FETCH_VIP_SUBSCRIPTION_FAILURE:
        case VIPCircleActionTypes.SEND_VIP_CIRCLE_FAILURE:
        case VIPCircleActionTypes.FETCH_OTHER_VIP_CIRCLE_FAILURE: {
            return Object.assign({}, state, {
                isLoading: false,
            });
        }

        default: {
            return state;
        }
    }
};

export { reducer as VIPCircleReducer };
